import Typograf from 'typograf';

/**
 * Typograf integration
 * @description Fix word wraps and other common typos
 */
export default defineNuxtPlugin((nuxtApp) => {
  const typografInstances = new Map();

  const getTypografInstance = (locale) => {
    if (!typografInstances.has(locale)) {
      const tp = new Typograf({ locale: [locale] });
      typografInstances.set(locale, tp);
    }
    return typografInstances.get(locale);
  };

  const defaultLocale = 'en-US';
  const defaultTypograf = getTypografInstance(defaultLocale);

  nuxtApp.provide('tp', (text, params = {}) => {
    if (!text) return '';

    const locale = params.locale;
    if (locale && Typograf.getLocales().includes(locale)) {
      const tp = getTypografInstance(locale);
      return tp.execute(text);
    }

    return defaultTypograf.execute(text);
  });
});
